import React from 'react'
import { IconFolder } from '@tabler/icons-react'
import Typography from '../atoms/Typography'

interface FolderRowProps {
  name: string
  onClick: () => void
  trailing: React.ReactNode
  disabled?: boolean
}

const FolderRow: React.FC<FolderRowProps> = ({ name, onClick, trailing, disabled }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className="flex w-full items-center justify-between rounded-lg bg-gray-700/60 px-4 py-3 transition-colors hover:bg-gray-700"
  >
    <div className="flex min-w-0 items-center gap-2">
      <IconFolder className="h-4 w-4 shrink-0 text-gray-50" />
      <Typography variant="sm" className="truncate font-medium text-gray-50">
        {name}
      </Typography>
    </div>
    {trailing}
  </button>
)

export default FolderRow
